import { useState } from 'react';
import cx from 'classnames';
import { format } from 'date-fns';
import { bool, func, number, oneOfType, shape, string } from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button } from '@fff-web/fff-ui-shared';
import {
  getReplenishmentSubscriptions,
  updateSubscriptionQuantity,
} from '../../../modules/replenishment';
import { CADENCE_VERBOSE_STRING } from '../../../utils/subscriptions';
import * as styles from './DetailProduct.module.scss';

const DetailProduct = ({ subscription, onCancelAction, updateSubscriptionQuantity }) => {
  const [quantity, _setQuantity] = useState(subscription?.quantity || 1);
  const [showSaveButton, setSaveShowButton] = useState(false);
  const nextRenewalDate = subscription?.nextRenewalDate
    ? format(subscription.nextRenewalDate, 'MMMM d')
    : 'Processing';

  // TODO: Add the logic for the quantity update when we have the correct endpoint on growth api
  // const handleQuantityChange = (event) => {
  //   const newQuantity = event.target.value;
  //   setQuantity(newQuantity);
  //   setSaveShowButton(true);
  // };

  const handleSaveChanges = () => {
    updateSubscriptionQuantity({
      variantId: subscription?.productId,
      operation: 'UPSERT_SUBSCRIPTION',
      cadenceType: subscription?.cadenceType,
      quantity: Number(quantity),
    }).then(() => {
      setSaveShowButton(false);
    });
  };

  return (
    <div className={styles.container} data-testid="detail-product-container">
      <h1 className={styles.title}>Subscription Details</h1>
      <div data-testid="detail-product" className={cx(styles.detailProduct)}>
        <div className={styles.imageContainer}>
          <img
            className={styles.image}
            alt={subscription?.description}
            src={subscription?.url}
            data-testid="image-container"
          />
        </div>
        <div className={styles.data}>
          <div>
            <div className={styles.brandName}>
              <h3 data-testid="product-brand">{subscription?.brand}</h3>
              <h3 data-testid="product-name">{subscription?.name}</h3>
            </div>
            {subscription?.description && (
              <div
                data-testid="product-description"
                className={styles.description}
                dangerouslySetInnerHTML={{ __html: subscription.description }}
              />
            )}
          </div>
          <div className={styles.subscriptionContainer}>
            <div data-testid="product-cadence" className={styles.quantity}>
              <span>Ships every:</span>
              {CADENCE_VERBOSE_STRING[subscription?.cadenceType]}
            </div>
            <div data-testid="product-next-renewal" className={styles.quantity}>
              <span>Next renewal:</span>
              {nextRenewalDate}
            </div>
            <div className={styles.quantity}>
              <span>Quantity:</span>
              {/* {!subscriptionsLimit || subscriptionsLimit < 2 ? ( */}
              {quantity}
              {/* TODO: Add the logic for the quantity update when we have the correct endpoint on growth api */}
              {/* ) : (
                <select
                  data-testid="product-quantity"
                  data-e2e="product-quantity"
                  value={quantity}
                  onChange={handleQuantityChange}
                >
                  {Array.from({ length: subscriptionsLimit }, (_, index) => (
                    <option key={index + 1} value={index + 1}>
                      {index + 1}
                    </option>
                  ))}
                </select>
              )} */}
            </div>
          </div>
        </div>
      </div>
      <div
        className={cx(styles.buttons, {
          [styles.hasSaveChangeButton]: showSaveButton,
        })}
      >
        {showSaveButton && (
          <div
            className={styles.saveChangesButton}
            data-testid="container-save-changes"
            data-e2e="container-save-changes"
          >
            <Button variation="black" onClick={handleSaveChanges}>
              Save changes
            </Button>
          </div>
        )}
        {!subscription?.isCancelled && (
          <div className={styles.buttonWrapper}>
            <Button onClick={onCancelAction}>
              <i className="far fa-ban" />
              Cancel subscription
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

DetailProduct.propTypes = {
  subscription: shape({
    productId: oneOfType([string, number]),
    brand: string,
    name: string.isRequired,
    quantity: number.isRequired,
    cadenceType: string,
    nextRenewalDate: string,
    url: string,
    description: string,
    subscriptionLimit: number,
    isActive: bool,
    isCancelled: bool,
  }).isRequired,
  onCancelAction: func.isRequired,
  updateSubscriptionQuantity: func,
};

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getReplenishmentSubscriptions,
      updateSubscriptionQuantity,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(DetailProduct);
